export default __webpack_public_path__ + "static/tuition-scholarships-mobile-69610e6447dd8970088fbf0218b126f9.jpg";